export default {
    data: () => ({
        discountSlide: '',
        discountCookieAmount: ''
    }),
    methods: {
        getCookie(cname){
            let name = cname + '=';
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++){
                let c = ca[i];
                while(c.charAt(0) == ' '){
                    c = c.substring(1);
                }
                if(c.indexOf(name) === 0){
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    },
    computed:{
        discountAmount(){
            if(this.discountCookieAmount.indexOf('15') >= 0){
                return '15%';
            }else if(this.discountCookieAmount.indexOf('30') >= 0){
                return '30%';
            }else if(this.discountCookieAmount.indexOf('45') >= 0){
                return '45%';
            }
            //Default
            return '40%';
        },
        vwoTesting(){
            return this.discountAmount !== '40%';
        }
    },
    mounted(){
        setInterval(()=>{
            if(this.getCookie('discount_experience')){
                this.discountCookieAmount = this.getCookie('discount_experience');
            }
        },100);
    }
};
